<template>
  <div class="mytable">
    <vxe-toolbar id="toolbarId_ho1">
      <template v-slot:buttons>
        <span class="seeMore" @click="toFreightStatistics">查看更多</span>
      </template>
    </vxe-toolbar>
    <vxe-table
      :footer-method="footerMethod"
      :footer-span-method="footerColspanMethod"
      show-footer
      border
      stripe
      height="261"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column field="shipmentName" title="发货联系人" span="4" />
      <vxe-table-column field="consigneeName" title="卸货联系人" span="4" />
      <vxe-table-column
        field="deliveryFeePractical"
        title="金额(元)"
        span="4"
      />
      <vxe-table-column field="settleTime" title="结算时间" span="4" />
    </vxe-table>
  </div>
</template>

<script>
import { getFeeList4Driver } from "@/api/statistics";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      feeSum: 0,
      tableData: []
    };
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    getOrderList() {
      getFeeList4Driver({ isDriver: 1 }).then(response => {
        let data = response.data;
        this.total = data.total;
        this.feeSum = data.sumObject ? data.sumObject : 0;
        this.tableData = data.records;
      });
    },
    toFreightStatistics() {
      this.$router.push("/tms/transportManage/Transport");
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计：" + this.feeSum + "元";
          }
          return null;
        })
      ];
    },
    footerColspanMethod({ columnIndex }) {
      if (columnIndex === 1) {
        return {
          rowspan: 1,
          colspan: 3
        };
      } else if (columnIndex > 1) {
        return {
          rowspan: 1,
          colspan: 0
        };
      }
    }
  }
};
</script>
<style lang="scss" type="text/scss">
.mytable {
  height: 300px;
  width: 100%;
  padding: 0 10px;
  background-color: #ffffff;
  .vxe-toolbar {
    height: 28px;
    line-height: 28px;
    min-height: 28px;
    padding-bottom: 0px;
    padding-top: 0px;
    text-align: right;
  }
  .vxe-table {
    .vxe-body--column {
      height: 38px;
    }
    .vxe-footer--row {
      background-color: #f1f1f1;
      .vxe-footer--column {
        border-right: 0px;
        height: 32px;
      }
    }
    .vxe-body--column:not(.col--ellipsis),
    .vxe-footer--column:not(.col--ellipsis),
    .vxe-header--column:not(.col--ellipsis) {
      padding: 6px 0;
    }
  }
  .vxe-table--body-wrapper {
    overflow-x: hidden;
  }
}
.seeMore {
  position: relative;
  top: -8px;
  width: 48px;
  height: 12px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(24, 144, 255, 1);
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
</style>
